export const badgeCollection = [
  {
    id: 'b01',
    name: 'Primer Saludo',
    description: 'Enviaste tu primer saludo en vivo a una radio RFW.',
    category: 'social',
    earned: true,
    earnedDate: '2026-05-12',
    progress: 100,
    icon: 'ri-message-2-line',
    color: 'bg-emerald-500',
    colorLight: 'bg-emerald-100',
    textColor: 'text-emerald-700',
    borderColor: 'border-emerald-300',
  },
  {
    id: 'b02',
    name: 'Primera Canción',
    description: 'Solicitaste tu primera canción al aire.',
    category: 'social',
    earned: true,
    earnedDate: '2026-05-15',
    progress: 100,
    icon: 'ri-music-line',
    color: 'bg-sky-500',
    colorLight: 'bg-sky-100',
    textColor: 'text-sky-700',
    borderColor: 'border-sky-300',
  },
  {
    id: 'b03',
    name: 'Primer Concurso',
    description: 'Participaste en tu primer concurso de radio.',
    category: 'social',
    earned: true,
    earnedDate: '2026-05-28',
    progress: 100,
    icon: 'ri-trophy-line',
    color: 'bg-amber-500',
    colorLight: 'bg-amber-100',
    textColor: 'text-amber-700',
    borderColor: 'border-amber-300',
  },
  {
    id: 'b04',
    name: '100 Horas',
    description: 'Acumulaste 100 horas de escucha en radios RFW.',
    category: 'listening',
    earned: true,
    earnedDate: '2026-06-04',
    progress: 100,
    icon: 'ri-timer-line',
    color: 'bg-primary-500',
    colorLight: 'bg-primary-100',
    textColor: 'text-primary-700',
    borderColor: 'border-primary-300',
  },
  {
    id: 'b05',
    name: '500 Horas',
    description: 'Medio millar de horas escuchando radios de la red.',
    category: 'listening',
    earned: false,
    earnedDate: null,
    progress: 25,
    progressLabel: '127 / 500 horas',
    icon: 'ri-timer-flash-line',
    color: 'bg-rose-500',
    colorLight: 'bg-rose-100',
    textColor: 'text-rose-700',
    borderColor: 'border-rose-300',
  },
  {
    id: 'b06',
    name: 'Top Fan',
    description: 'Alcanzaste el nivel Top Fan en la comunidad RFW.',
    category: 'status',
    earned: true,
    earnedDate: '2026-06-10',
    progress: 100,
    icon: 'ri-fire-line',
    color: 'bg-orange-500',
    colorLight: 'bg-orange-100',
    textColor: 'text-orange-700',
    borderColor: 'border-orange-300',
  },
  {
    id: 'b07',
    name: 'VIP',
    description: 'Accediste al círculo VIP de oyentes premium.',
    category: 'status',
    earned: false,
    earnedDate: null,
    progress: 67,
    progressLabel: '4,850 / 6,000 pts',
    icon: 'ri-vip-diamond-line',
    color: 'bg-amber-500',
    colorLight: 'bg-amber-100',
    textColor: 'text-amber-700',
    borderColor: 'border-amber-300',
  },
  {
    id: 'b08',
    name: 'Embajador',
    description: 'El máximo reconocimiento: Embajador oficial de RFW.',
    category: 'status',
    earned: false,
    earnedDate: null,
    progress: 32,
    progressLabel: '4,850 / 15,000 pts',
    icon: 'ri-vip-crown-line',
    color: 'bg-rose-500',
    colorLight: 'bg-rose-100',
    textColor: 'text-rose-700',
    borderColor: 'border-rose-300',
  },
];

export const badgeStats = {
  totalBadges: 8,
  earnedBadges: 5,
  lockedBadges: 3,
  completionPercent: 63,
  nextBadge: '500 Horas',
  pointsToNextBadge: '373 horas restantes',
  recentBadge: {
    name: 'Top Fan',
    date: '2026-06-10',
    icon: 'ri-fire-line',
    color: 'bg-orange-500',
  },
  rarestBadge: {
    name: 'Top Fan',
    percentage: '12% de oyentes',
    icon: 'ri-fire-line',
    color: 'bg-orange-500',
  },
};